import { read } from "Helpers/LocalStorage";
import { analyzeActionCode } from "Stores/actions";
import { readToken } from "Helpers/Token";
import { baseURL } from "./ApiSettings";
import { HttpTransportType, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

let connectionStatus = false;

export const SocketConnection = () => {
  return async (dispatch, getState) => {
    const state = getState();
    if(state.auth.isLoggedIn) {
      if (!connectionStatus) {
        connectionStatus = true;
        const startTime = Date.now();
        const tokenBearer = readToken();
        const options = {
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets
        };
        const connection = new HubConnectionBuilder()
          .withUrl(`${baseURL}/support/callcenter?token=${tokenBearer}`, options)
          .configureLogging(LogLevel.None)
          .withAutomaticReconnect()
          .build();
        connection.serverTimeoutInMilliseconds = 1000 * 60 * 10;
        connection.logging = false;
        connection.on("Recive", async (data) => {
          // console.log('Action code received:', data.action);
          dispatch(analyzeActionCode(data.action));
        });
        connection.onclose(() => {
          console.warn("Connection closed");
          connectionStatus = false;
        });
        try {
          await connection.start();
          const connectionId = await connection.invoke("JoinCallCenter", {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
          });
          console.warn(`WS(${connectionId}) - ${(Date.now() - startTime)}ms`);
        } catch (error) {
          console.error("WebSocket connection failed:", error);
          connectionStatus = false;
        }
      }
    }
  };
};
